import React from 'react';
import CountDownTimer from './CountDownTimer';

const FlashMessage = ({
    cssIcon,
    messageText, 
    linkText,
    linkToPageUrl,
    timeToLive = 0, 
    dismissible, 
    messageType,
    onDelete,
    }) => {
    return(
        <div className={`flash-message ${messageType && 'flash-message--' + messageType.toLowerCase()}`}>
            {!!cssIcon && (
                <div className='flash-message__icon'>
                    <i className={`icon-${cssIcon}`} />
                </div>)}
            <div className="flash-message__content">
                <div dangerouslySetInnerHTML={ {__html: messageText} } />
                {(linkToPageUrl && linkText) && (
                    <div className="flash-message__content__link">
                        <a href={linkToPageUrl}>{linkText}</a>
                    </div>
                )}
            </div>
            <div>
                <div className="flash-message__close">
                    {dismissible && <button onClick={() => onDelete({ closedByUser: true })}><i className="icon-cancel flash-message__close__icon" /></button>}
                    {timeToLive !== 0 && <CountDownTimer radius={15} color={"#fff"} durationInSeconds={timeToLive} onTimerTimeout={() => onDelete({closedByUser : false})} />}
                </div>
            </div>
            
        </div>
    )
}

export default FlashMessage;
